module.exports = __webpack_public_path__ + "static/mpost53.8138c54e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slideshow/mpost53.jpg
// module id = 255
// module chunks = 35783957827783 269829036549620